import { TypeDefinition } from "../generic";

export type EventTypeDefinition = TypeDefinition & {
    levelId: number;
};

export class EventTypes {
    public static AnnualMeetings: EventTypeDefinition = { id: 1, name: "Annual Meetings", levelId: 0 };
    public static Award: EventTypeDefinition = { id: 2, name: "Award", levelId: 1 };
    public static Cases: EventTypeDefinition = { id: 3, name: "Cases", levelId: 1 };
    public static FilmFestival: EventTypeDefinition = { id: 4, name: "Film Festival", levelId: 1 };
    public static InstructionalCourse: EventTypeDefinition = { id: 5, name: "Instructional Course", levelId: 1 };
    public static InterimEvent: EventTypeDefinition = { id: 6, name: "Interim Event", levelId: 1 };
    public static PODSession: EventTypeDefinition = { id: 7, name: "POD Session", levelId: 1 };
    public static PosterSession: EventTypeDefinition = { id: 8, name: "Poster Session", levelId: 1 };
    public static Symposium: EventTypeDefinition = { id: 9, name: "Symposium", levelId: 1 };

    public static Values: EventTypeDefinition[] = [
        EventTypes.AnnualMeetings,
        EventTypes.Award,
        EventTypes.Cases,
        EventTypes.FilmFestival,
        EventTypes.InstructionalCourse,
        EventTypes.InterimEvent,
        EventTypes.PODSession,
        EventTypes.PosterSession,
        EventTypes.Symposium,
    ];

    public static MainLevelTypes = EventTypes.Values.filter((v) => v.levelId === 0);
    public static SubEventTypes = EventTypes.Values.filter((v) => v.levelId === 1);
    public static SessionTypes = EventTypes.Values.filter((v) => v.levelId === 2);
}



// WEBPACK FOOTER //
// ./src/models/event/EventTypes.ts